<div class="container-fluid py-5">
    <div class="col-md-9 cah-signup-card offset-0 offset-md-2 offset-lg-2 offset-md-0  mt-0 mt-lg-5">
        <div class="d-flex">
            <div class="cah-signup-sec px-0 shadow d-lg-block d-none d-sm-none">
                <div class="py-5 cah-p-lr-40 text-white">
                    <h1 class="fw-bolder cah-font-35 mb-4">Primary Care<br>Veterinarian<br>Sign Up</h1>
                    <p class="cah-font-16 mb-5" *ngIf="step == 1">Sign Up with your details to get started</p>
                    <p class="cah-font-16 mb-5" *ngIf="step == 2">Set Password</p>
                    <div class="text-center py-5"><img class="cah-p-t-25"
                            src="{{assets}}img/auth/vets-sign-in-img.webp"></div>
                </div>
            </div>


            <div class="w-100 px-0">

                <div class="pt-5 px-5 w-100 cah-sign-up-step" [class.d-block]="step == 1">
                    <h3 class="cah-font-22 mb-3">Would You like to Sign up as a : </h3>
                    <div class="field-content">

                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>User Type</mat-label>
                            <mat-select (selectionChange)="setUserForm($event)" required>
                                <mat-option value="Veterinary Clinic">
                                    Veterinary Clinic
                                </mat-option>
                                <mat-option value="Individual Veterinarian">
                                    Individual Veterinarian
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <!-- <div class="mat--error message-block">
                    <div class="mat-error error-message"
                        *ngIf="signupFormGroup.controls['country'].hasError('required') && signupFormGroup.controls['country'].touched">
                        {{message.error[67]}}</div>
                </div> -->
                    </div>
                </div>
                <form [formGroup]="signupFormGroup" *ngIf="showPcv">
                    <div class="w-100 cah-sign-up-step" [class.d-block]="step == 1">
                        <div class="pt-0 px-5">
                            <h1 class="cah-m-b-30 fw-bolder text-center text-violet d-block d-lg-none">Primary Care
                                Veterinarian Sign Up</h1>
                            <div class="field-content">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Enter First Name</mat-label>
                                    <input matInput required formControlName="firstName" maxlength="50"
                                        appInputTitleCase appTrim>
                                </mat-form-field>
                                <div class="mat--error message-block">
                                    <div class="mat-error error-message"
                                        *ngIf="signupFormGroup.controls['firstName'].hasError('required')  && signupFormGroup.controls['firstName'].touched">
                                        {{message.error[1]}}</div>
                                    <div class="mat-error error-message"
                                        *ngIf="!signupFormGroup.controls['firstName'].hasError('required') && signupFormGroup.controls['firstName'].value.trim().length == 0  && signupFormGroup.controls['firstName'].touched">
                                        {{message.error[2]}}</div>

                                </div>
                            </div>
                            <div class="field-content">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Enter Last Name</mat-label>
                                    <input formControlName="lastName" matInput required maxlength="50"
                                        appInputTitleCase appTrim>
                                </mat-form-field>
                                <div class="mat--error message-block">
                                    <div class="mat-error error-message"
                                        *ngIf="signupFormGroup.controls['lastName'].hasError('required') && signupFormGroup.controls['lastName'].touched">
                                        {{message.error[3]}}</div>
                                    <div class="mat-error error-message"
                                        *ngIf="!signupFormGroup.controls['lastName'].hasError('required') && signupFormGroup.controls['lastName'].value.trim().length == 0  && signupFormGroup.controls['lastName'].touched">
                                        {{message.error[4]}}</div>

                                </div>
                            </div>
                            <div class="field-content">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Country</mat-label>
                                    <mat-select formControlName="country" (selectionChange)="setStateValue($event)"
                                        required appTrim>
                                        <mat-option *ngFor="let country of countries" [value]="country">
                                            {{country}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <div class="mat--error message-block">
                                    <div class="mat-error error-message"
                                        *ngIf="signupFormGroup.controls['country'].hasError('required') && signupFormGroup.controls['country'].touched">
                                        {{message.error[67]}}</div>
                                </div>
                            </div>
                            <div *ngIf=" this.signupFormGroup.value.country == 'Other' " class="field-content">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Other Country</mat-label>
                                    <input formControlName="otherCountry" matInput appInputTitleCase appTrim>
                                </mat-form-field>
                                <div class="mat--error message-block">
                                    <div class="mat-error error-message"
                                        *ngIf="signupFormGroup.controls['otherCountry'].hasError('required') && signupFormGroup.controls['otherCountry'].touched">
                                        {{message.error[67]}}</div>
                                    <div class="mat-error error-message"
                                        *ngIf="signupFormGroup.controls['otherCountry'].hasError('pattern') && signupFormGroup.controls['otherCountry'].touched">
                                        {{message.error[67]}}</div>
                                </div>
                            </div>
                            <div *ngIf=" this.signupFormGroup.value.country !== 'Other' " class="field-content">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>License State/Territory</mat-label>
                                    <mat-select formControlName="licenseState"
                                        (selectionChange)="checkOtherOption($event)" required>
                                        <mat-option *ngFor="let state of statesList" [value]="state">
                                            {{state}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>

                                <div class="mat--error message-block">
                                    <div class="mat-error error-message"
                                        *ngIf="signupFormGroup.controls['country'].hasError('required')  && signupFormGroup.controls['licenseState'].touched">
                                        Please select your country first.</div>
                                    <div class="mat-error error-message"
                                        *ngIf="!signupFormGroup.controls['country'].hasError('required') && signupFormGroup.controls['licenseState'].hasError('required') && signupFormGroup.controls['licenseState'].touched">
                                        {{message.error[40]}}</div>
                                    <div class="mat-error error-message"
                                        *ngIf="signupFormGroup.controls['licenseState'].hasError('pattern') && signupFormGroup.controls['licenseState'].touched">
                                        {{message.error[41]}}</div>
                                </div>
                            </div>
                            <div *ngIf=" this.signupFormGroup.value.licenseState == 'Other' || this.signupFormGroup.value.country == 'Other' "
                                class="field-content">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Other License State/Territory</mat-label>
                                    <input formControlName="otherLicenseState" matInput appInputTitleCase appTrim>
                                </mat-form-field>
                                <div class="mat--error message-block">
                                    <div class="mat-error error-message"
                                        *ngIf="signupFormGroup.controls['otherLicenseState'].hasError('required') && signupFormGroup.controls['otherLicenseState'].touched">
                                        {{message.error[82]}}</div>
                                    <div class="mat-error error-message"
                                        *ngIf="signupFormGroup.controls['otherLicenseState'].hasError('pattern') && signupFormGroup.controls['otherLicenseState'].touched">
                                        {{message.error[62]}}</div>
                                </div>
                            </div>
                            <div class="field-content"> 
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Enter License Number</mat-label>
                                    <input maxlength="12" required (keyup)="checkLicenseNumber()"
                                        formControlName="licenseNumber" appAutocapitalizeall matInput appTrim>
                                    <mat-icon style="font-family: Material Icons Outlined !important;" class="material-icons-outlined" (click)="tooltip.toggle()"
                                        #tooltip="matTooltip" matSuffix
                                        matTooltip='If you are licensed in more than one state/ territory, you only need to list one license. This is for verification purposes only. If you would like to list additional licenses or states of practice, you may do so in the "about me" section of your profile.'>info</mat-icon>
                                </mat-form-field>
                                <div class="mat--error message-block">
                                    <div class="mat-error error-message"
                                        *ngIf="signupFormGroup.controls['licenseNumber'].hasError('required') && signupFormGroup.controls['licenseNumber'].touched">
                                        {{message.error[11]}}</div>
                                    <div class="mat-error error-message"
                                        *ngIf="signupFormGroup.controls['licenseNumber'].hasError('isLicenseNumberExist')">
                                        {{message.error[22]}}</div>
                                </div>
                            </div>

                            <div class="field-content">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>License Expiration Date</mat-label>
                                    <input matInput required [min]="minDate" [matDatepicker]="picker1"
                                        (focus)="picker1.open()" name="licenseExpiryDate"
                                        [formControl]="licenseExpiryDate">
                                    <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                                    <mat-datepicker #picker1></mat-datepicker>
                                </mat-form-field>
                                <div class="mat--error message-block">
                                    <mat-error
                                        *ngIf="licenseExpiryDate.invalid && licenseExpiryDate.touched">{{message.error[44]}}</mat-error>
                                </div>
                            </div>


                            <div class="field-content">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Enter Email Address</mat-label>
                                    <input maxlength="60" required (keyup)="checkEmail()" formControlName="email"
                                        matInput appTrim>
                                </mat-form-field>
                                <div class="mat--error message-block">
                                    <div class="mat-error error-message"
                                        *ngIf="signupFormGroup.controls['email'].hasError('required') && signupFormGroup.controls['email'].touched">
                                        {{message.error[13]}}</div>
                                    <div class="mat-error error-message"
                                        *ngIf="signupFormGroup.controls['email'].hasError('pattern') && signupFormGroup.controls['email'].touched">
                                        {{message.error[14]}}</div>
                                    <div class="mat-error error-message"
                                        *ngIf="signupFormGroup.controls['email'].hasError('isEmailExist')">
                                        {{message.error[21]}}</div>
                                </div>
                            </div>
                            <div class="field-content">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Liability Insurance Provider</mat-label>
                                    <input required formControlName="liabilityInsuranceProvider" appInputTitleCase
                                        matInput appTrim>
                                </mat-form-field>
                                <div class="mat--error message-block">
                                    <div class="mat-error error-message"
                                        *ngIf="signupFormGroup.controls['liabilityInsuranceProvider'].hasError('required') && signupFormGroup.controls['liabilityInsuranceProvider'].touched">
                                        {{message.error[63]}}</div>
                                </div>
                            </div>
                            <div class="field-content">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Expiration Date of Liability Insurance</mat-label>
                                    <input matInput required [matDatepicker]="picker" (focus)="picker.open()"
                                        [min]="minDate" [formControl]="malpracticeInsuranceExpiryDate"
                                        name="malpracticeInsuranceExpiryDate">
                                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                    <mat-datepicker #picker></mat-datepicker>
                                </mat-form-field>
                                <div class="mat--error message-block">
                                    <mat-error
                                        *ngIf="malpracticeInsuranceExpiryDate.invalid && malpracticeInsuranceExpiryDate.touched">{{message.error[45]}}</mat-error>
                                </div>
                            </div>
                            <div class="pt-2" *ngIf="!showDocPreview">
                                <label style="cursor: pointer;" for="cah-document-upload"
                                    class="col-lg-12 col-md-12 col-sm-12 col-xs-12 cah-drop-area mb-4">
                                    <div class="text-center">
                                        <span class="material-icons text-violet cah-font-70">cloud_upload</span>
                                        <p class="text-violet cah-fw-500 pt-3">Upload Image Driving License/Other State
                                            Issued ID</p>
                                    </div>
                                </label>
                                <input type="file" name="driving_license" id="cah-document-upload"
                                    class="visually-hidden" (change)="readImage($event);" accept="image/*">
                                <mat-error *ngIf="imageUploadError">{{imageUploadError}}</mat-error>

                            </div>
                            <div class="row pt-2" *ngIf="showDocPreview">
                                <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12 col-12 mb-3">
                                    <div class="cah-document-wraper">
                                        <div class="d-flex justify-content-end me-2">
                                            <div
                                                class="cah-edit-bg d-flex align-items-center justify-content-center me-5">
                                                <label for="cah-edit-document-upload"
                                                    class=" d-flex align-items-center justify-content-center">
                                                    <span style="cursor: pointer;"
                                                        class="material-icons-outlined text-white cah-font-20">edit</span>
                                                </label>
                                                <input type="file" name="edit_driving_license"
                                                    id="cah-edit-document-upload" (change)="readImage($event);"
                                                    class="visually-hidden">
                                            </div>
                                            <div class="cah-remove-bg d-flex align-items-center justify-content-center">
                                                <span style="cursor: pointer;"
                                                    class="material-icons text-white cah-font-18"
                                                    (click)="deleteFile()">delete</span>
                                            </div>
                                        </div>
                                        <div class="border border-bottom-0 cah-document-img-wrap mb-0">
                                            <img [src]="imageSrc" class="img-fluid w-100">
                                        </div>
                                        <div class="cah-id-bottom">
                                            <p class="cah-fw-500 py-3 py-lg-3 py-sm-3 py-md-3 py-xs-3 mb-0">{{fileName}}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="px-5">
                            <button type="button"
                                [disabled]="!this.signupFormGroup.valid || !licenseExpiryDate.valid || !malpracticeInsuranceExpiryDate.valid || signupFormGroup.controls['firstName'].value.trim().length == 0 || signupFormGroup.controls['lastName'].value.trim().length == 0 "
                                class="btn btn-violet btn-lg w-100 fs-5 h-60 mt-2" (click)="submitForm()">Sign
                                Up</button>
                            <div class="text-center mt-4 pb-5">
                                <span class="text-gray cah-font-16">Already have an account?</span><a
                                    class="create-acc-link text-violet text-decoration-none ms-1 cah-font-16"
                                    routerLink="../pcv-signin">Sign In</a>
                            </div>
                        </div>
                    </div>
                </form>
                <form [formGroup]="veterinarianFormGroup" *ngIf="showClinic">
                    <div class="w-100 cah-sign-up-step" [class.d-block]="step == 1">
                        <div class="pt-0 px-5">
                            <h1 class="cah-m-b-30 fw-bolder text-center text-violet d-block d-lg-none">Primary Care
                                Veterinarian Sign Up</h1>
                            <div class="field-content">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Practice Name</mat-label>
                                    <input matInput maxlength="50" formControlName="practiceName" required
                                        appInputTitleCase appTrim>
                                </mat-form-field>
                                <div class="mat--error message-block">
                                    <div class="mat-error error-message"
                                        *ngIf="veterinarianFormGroup.controls['practiceName'].hasError('required') && veterinarianFormGroup.controls['practiceName'].touched">
                                        {{message.error[34]}}</div>
                                    <div class="mat-error error-message"
                                        *ngIf="veterinarianFormGroup.controls['practiceName'].hasError('pattern') && veterinarianFormGroup.controls['practiceName'].touched">
                                        {{message.error[35]}}</div>
                                </div>
                            </div>

                            <div class="field-content">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Practice Address</mat-label>
                                    <input matInput formControlName="practiceAddress" id="txtSearchPlaces1" appTrim>
                                </mat-form-field>
                                <div class="mat--error message-block">
                                    <div class="mat-error error-message"
                                        *ngIf="veterinarianFormGroup.controls['practiceAddress'].hasError('required') && veterinarianFormGroup.controls['practiceAddress'].touched">
                                        {{message.error[19]}}</div>
                                    <div class="mat-error error-message"
                                        *ngIf="veterinarianFormGroup.controls['practiceAddress'].hasError('pattern') && veterinarianFormGroup.controls['practiceAddress'].touched">
                                        {{message.error[20]}}</div>
                                    <div class="mat-error error-message"
                                        *ngIf="veterinarianFormGroup.controls['practiceAddress'].hasError('whitespace') && veterinarianFormGroup.controls['practiceAddress'].touched">
                                        {{message.error[20]}}</div>
                                </div>
                            </div>

                            <div class="field-content">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Practice Phone Number</mat-label>
                                    <input mask="(000) 000-0000" placeholder="(___) ___-____"  formControlName="contactNumber" [validation]="true" [dropSpecialCharacters]="false" required matInput>
                                </mat-form-field>
                                <div class="mat--error message-block">
                                    <div class="mat-error error-message"
                                        *ngIf="veterinarianFormGroup.controls['contactNumber'].hasError('required') && veterinarianFormGroup.controls['contactNumber'].touched ">
                                        {{message.error[36]}}</div>
                                    <div class="mat-error error-message"
                                        *ngIf="veterinarianFormGroup.controls['contactNumber'].hasError('whitespace') && veterinarianFormGroup.controls['contactNumber'].touched ">
                                        {{message.error[37]}}</div>

                                    <div class="mat-error error-message"
                                        *ngIf="veterinarianFormGroup.controls['contactNumber'].hasError('pattern') && veterinarianFormGroup.controls['contactNumber'].touched ">
                                        {{message.error[37]}}</div>
                                </div>
                            </div>

                            <div class="field-content">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Primary Hospital Contact Email</mat-label>
                                    <input maxlength="60" (keyup)="checkEmail()" formControlName="email" required
                                        matInput appTrim>
                                    <mat-icon class="material-icons-outlined" (click)="tooltip1.toggle()"
                                        #tooltip1="matTooltip" matSuffix
                                        matTooltip='Please choose an email address that is monitored frequently. All case related communications and notifications will come to this email address. This should be an email address that can be accessed by all of the doctors and staff who use Stratocyte.'>info</mat-icon>
                                </mat-form-field>
                                <div class="mat--error message-block">
                                    <div class="mat-error error-message"
                                        *ngIf="veterinarianFormGroup.controls['email'].hasError('required') && veterinarianFormGroup.controls['email'].touched">
                                        {{message.error[13]}}</div>
                                    <div class="mat-error error-message"
                                        *ngIf="veterinarianFormGroup.controls['email'].hasError('pattern') && veterinarianFormGroup.controls['email'].touched">
                                        {{message.error[14]}}</div>
                                    <div class="mat-error error-message"
                                        *ngIf="veterinarianFormGroup.controls['email'].hasError('isEmailExist')">
                                        {{message.error[21]}}</div>
                                </div>
                            </div>
                            <div class="field-content">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Hospital Contact Name</mat-label>
                                    <input maxlength="60" formControlName="secondaryContactName" matInput appTrim>
                                    <mat-icon class="material-icons-outlined" (click)="tooltip2.toggle()"
                                        #tooltip2="matTooltip" matSuffix
                                        matTooltip='Please let us know who we should contact if we have questions or important information regarding your account. This contact does not have to be a DVM.'>info</mat-icon>
                                </mat-form-field>

                            </div>
                            <!-- <div class="field-content">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Secondary Hospital Contact Email</mat-label>
                                    <input maxlength="60" formControlName="secondaryContactemail" matInput>
                                </mat-form-field>
                            </div> -->

                            <div class="field-content fieldplusminus">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>DVM Contact Name</mat-label>
                                    <input matInput formControlName="dvmContactName" maxlength="50" appTrim required>
                                    <mat-icon class="material-icons-outlined" (click)="tooltip3.toggle()"
                                        #tooltip3="matTooltip" matSuffix
                                        matTooltip='We ask you to provide a veterinarian’s contact information (name, photo ID, and license information) to protect your hospital and doctors. By asking you to provide information that only you would have, we attempt to avoid someone outside of your hospital creating an account on your behalf.'>info</mat-icon>
                                </mat-form-field>
                                <!-- <div class="mat--error message-block">
                                    <div class="mat-error error-message"
                                        *ngIf="veterinarianFormGroup.get('dvmNames')?.invalid && veterinarianFormGroup.controls['dvmNames'].touched">
                                        {{message.error[34]}}</div>
                                    <div class="mat-error error-message"
                                        *ngIf="veterinarianFormGroup.controls['dvmNames'].hasError('pattern') && veterinarianFormGroup.controls['dvmNames'].touched">
                                        {{message.error[35]}}</div>
                                </div> -->
                            </div>
                            <div class="field-content">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>DVM Contact License Number</mat-label>
                                    <input maxlength="12" required (keyup)="checkLicenseNumber()"
                                        formControlName="licenseNumber" appTrim appAutocapitalizeall matInput>
                                </mat-form-field>
                                <div class="mat--error message-block">
                                    <div class="mat-error error-message"
                                        *ngIf="veterinarianFormGroup.controls['licenseNumber'].hasError('required') && veterinarianFormGroup.controls['licenseNumber'].touched">
                                        {{message.error[11]}}</div>
                                    <div class="mat-error error-message"
                                        *ngIf="veterinarianFormGroup.controls['licenseNumber'].hasError('isLicenseNumberExist')">
                                        {{message.error[22]}}</div>
                                </div>
                            </div>
                            <div class="field-content">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Country</mat-label>
                                    <mat-select formControlName="country" appTrim (selectionChange)="setStateValue($event)"
                                        required>
                                        <mat-option *ngFor="let country of countries" [value]="country">
                                            {{country}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <div class="mat--error message-block">
                                    <div class="mat-error error-message"
                                        *ngIf="veterinarianFormGroup.controls['country'].hasError('required') && veterinarianFormGroup.controls['country'].touched">
                                        {{message.error[67]}}</div>
                                </div>
                            </div>
                            <div *ngIf="this.veterinarianFormGroup.value.country !== 'Other' " class="field-content">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>DVM Contact License State</mat-label>
                                    <mat-select formControlName="dvmLicenseState"
                                        (selectionChange)="checkOtherOption($event)" required>
                                        <mat-option *ngFor="let state of statesList" [value]="state">
                                            {{state}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>

                                <div class="mat--error message-block">
                                    <div class="mat-error error-message"
                                        *ngIf="veterinarianFormGroup.controls['country'].hasError('required')  && veterinarianFormGroup.controls['dvmLicenseState'].touched">
                                        Please select your country first.</div>
                                    <div class="mat-error error-message"
                                        *ngIf="!veterinarianFormGroup.controls['country'].hasError('required') && veterinarianFormGroup.controls['dvmLicenseState'].hasError('required') && veterinarianFormGroup.controls['dvmLicenseState'].touched">
                                        {{message.error[40]}}</div>
                                    <div class="mat-error error-message"
                                        *ngIf="veterinarianFormGroup.controls['dvmLicenseState'].hasError('pattern') && veterinarianFormGroup.controls['dvmLicenseState'].touched">
                                        {{message.error[41]}}</div>
                                </div>
                            </div>
                            <div *ngIf="this.veterinarianFormGroup.value.dvmLicenseState == 'Other' || this.veterinarianFormGroup.value.country == 'Other' "
                                class="field-content">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Other License State/Territory</mat-label>
                                    <input formControlName="otherLicenseState" appTrim matInput appInputTitleCase>
                                </mat-form-field>
                                <div class="mat--error message-block">
                                    <div class="mat-error error-message"
                                        *ngIf="veterinarianFormGroup.controls['otherLicenseState'].hasError('required') && veterinarianFormGroup.controls['otherLicenseState'].touched">
                                        {{message.error[82]}}</div>
                                    <div class="mat-error error-message"
                                        *ngIf="veterinarianFormGroup.controls['otherLicenseState'].hasError('pattern') && veterinarianFormGroup.controls['otherLicenseState'].touched">
                                        {{message.error[62]}}</div>
                                </div>
                            </div>

                            <div class="field-content fieldplusminus">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>DVM Contact License Expiration Date</mat-label>
                                    <input matInput required [min]="minDate" [matDatepicker]="picker1"
                                        (focus)="picker1.open()" name="dvmlicenseExpiryDate"
                                        formControlName="dvmlicenseExpiryDate">
                                    <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                                    <mat-datepicker #picker1></mat-datepicker>
                                </mat-form-field>
                                <div>
                                    <mat-error
                                        *ngIf="veterinarianFormGroup.get('dvmlicenseExpiryDate')?.invalid && veterinarianFormGroup.get('dvmlicenseExpiryDate')?.touched">{{message.error[44]}}</mat-error>
                                </div>
                               
                                <mat-icon color="primary" type="button" class="btnicon" (click)="addEmployee()">
                                    add
                                </mat-icon>

                            </div>
                            <div formArrayName="employees">
                                <div *ngFor="let employee of employees().controls; let empIndex=index">
                                    <div [formGroupName]="empIndex">
                                        <div class="field-content">
                                            <mat-form-field appearance="outline" class="w-100">
                                                <mat-label>Additional DVM Contact Name</mat-label>
                                                <input matInput formControlName="dvmName" appTrim maxlength="50">
                                            </mat-form-field>

                                        </div>
                                        <div class="field-content">
                                            <mat-form-field appearance="outline" class="w-100">
                                                <mat-label>DVM Contact License Number</mat-label>
                                                <input maxlength="12" required (keyup)="checkLicenseNumber()"
                                                    formControlName="licenseNumber" appAutocapitalizeall appTrim matInput>
                                            </mat-form-field>
                                            <div class="mat--error message-block">
                                                <div class="mat-error error-message"
                                                    *ngIf="veterinarianFormGroup.controls['licenseNumber'].hasError('required') && veterinarianFormGroup.controls['licenseNumber'].touched">
                                                    {{message.error[11]}}</div>
                                                <div class="mat-error error-message"
                                                    *ngIf="veterinarianFormGroup.controls['licenseNumber'].hasError('isLicenseNumberExist')">
                                                    {{message.error[22]}}</div>
                                            </div>
                                        </div>
                                        <div class="field-content">
                                            <mat-form-field appearance="outline" class="w-100">
                                                <mat-label>Country</mat-label>
                                                <mat-select formControlName="country"
                                                    (selectionChange)="setStateValue($event)" required>
                                                    <mat-option *ngFor="let country of countries" [value]="country">
                                                        {{country}}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                            <div class="mat--error message-block">
                                                <div class="mat-error error-message"
                                                    *ngIf="veterinarianFormGroup.controls['country'].hasError('required') && veterinarianFormGroup.controls['country'].touched">
                                                    {{message.error[67]}}</div>
                                            </div>
                                        </div>
                                        <div *ngIf="this.veterinarianFormGroup.value.country !== 'Other' "
                                            class="field-content">
                                            <mat-form-field appearance="outline" class="w-100">
                                                <mat-label>DVM Contact License State</mat-label>
                                                <mat-select formControlName="licenseState"
                                                    (selectionChange)="checkOtherOption($event)" required>
                                                    <mat-option *ngFor="let state of statesList" [value]="state">
                                                        {{state}}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>

                                            <div class="mat--error message-block">
                                                <div class="mat-error error-message"
                                                    *ngIf="veterinarianFormGroup.controls['country'].hasError('required')  && veterinarianFormGroup.controls['dvmLicenseState'].touched">
                                                    Please select your country first.</div>
                                                <div class="mat-error error-message"
                                                    *ngIf="!veterinarianFormGroup.controls['country'].hasError('required') && veterinarianFormGroup.controls['dvmLicenseState'].hasError('required') && veterinarianFormGroup.controls['dvmLicenseState'].touched">
                                                    {{message.error[40]}}</div>
                                                <div class="mat-error error-message"
                                                    *ngIf="veterinarianFormGroup.controls['dvmLicenseState'].hasError('pattern') && veterinarianFormGroup.controls['dvmLicenseState'].touched">
                                                    {{message.error[41]}}</div>
                                            </div>
                                        </div>
                                        <div *ngIf="this.veterinarianFormGroup.value.dvmLicenseState == 'Other' || this.veterinarianFormGroup.value.country == 'Other' "
                                            class="field-content">
                                            <mat-form-field appearance="outline" class="w-100">
                                                <mat-label>Other License State/Territory</mat-label>
                                                <input formControlName="otherLicenseState" appTrim matInput appInputTitleCase>
                                            </mat-form-field>
                                            <div class="mat--error message-block">
                                                <div class="mat-error error-message"
                                                    *ngIf="veterinarianFormGroup.controls['otherLicenseState'].hasError('required') && veterinarianFormGroup.controls['otherLicenseState'].touched">
                                                    {{message.error[82]}}</div>
                                                <div class="mat-error error-message"
                                                    *ngIf="veterinarianFormGroup.controls['otherLicenseState'].hasError('pattern') && veterinarianFormGroup.controls['otherLicenseState'].touched">
                                                    {{message.error[62]}}</div>
                                            </div>
                                        </div>

                                        <div class="field-content fieldplusminus">
                                            <mat-form-field appearance="outline" class="w-100">
                                                <mat-label>DVM Contact License Expiration Date</mat-label>
                                                <input matInput required [min]="minDate" [matDatepicker]="picker"
                                                    (focus)="picker.open()" name="dvmlicenseExpiryDate"
                                                    formControlName="dvmlicenseExpiryDate">
                                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                                <mat-datepicker #picker></mat-datepicker>
                                            </mat-form-field>
                                            <!-- <div class="mat--error message-block">
                                                <mat-error
                                                    *ngIf="license2ExpiryDate.invalid && license2ExpiryDate.touched">{{message.error[44]}}</mat-error>
                                            </div> -->

                                            <mat-icon type="button" color="accent" class="btnicon"
                                                (click)="removeEmployee(empIndex)">
                                                remove
                                            </mat-icon>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="pt-2" *ngIf="!showDocPreview">
                                <label style="cursor: pointer;" for="cah-document-upload"
                                    class="col-lg-12 col-md-12 col-sm-12 col-xs-12 cah-drop-area mb-4">
                                    <div class="text-center">
                                        <span class="material-icons text-violet cah-font-70">cloud_upload</span>
                                        <p class="text-violet cah-fw-500 pt-3">Photo ID of DVM Contact</p>
                                        <mat-icon class="material-icons-outlined" (click)="tooltip.toggle()"
                                            #tooltip="matTooltip" matSuffix
                                            matTooltip='We ask you to provide a veterinarian’s contact information (name, photo ID, and license information) to protect your hospital and doctors. By asking you to provide information that only you would have, we attempt to avoid someone outside of your hospital creating an account on your behalf.'>info</mat-icon>
                                    </div>

                                </label>

                                <input type="file" name="driving_license" id="cah-document-upload"
                                    class="visually-hidden" (change)="readImage($event);" accept="image/*">

                                <mat-error *ngIf="imageUploadError">{{imageUploadError}}</mat-error>

                            </div>
                            <div class="row pt-2" *ngIf="showDocPreview">
                                <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12 col-12 mb-3">
                                    <div class="cah-document-wraper">
                                        <div class="d-flex justify-content-end me-2">
                                            <div
                                                class="cah-edit-bg d-flex align-items-center justify-content-center me-5">
                                                <label for="cah-edit-document-upload"
                                                    class=" d-flex align-items-center justify-content-center">
                                                    <span style="cursor: pointer;"
                                                        class="material-icons-outlined text-white cah-font-20">edit</span>
                                                </label>
                                                <input type="file" name="edit_driving_license"
                                                    id="cah-edit-document-upload" (change)="readImage($event);"
                                                    class="visually-hidden">
                                            </div>
                                            <div class="cah-remove-bg d-flex align-items-center justify-content-center">
                                                <span style="cursor: pointer;"
                                                    class="material-icons text-white cah-font-18"
                                                    (click)="deleteFile()">delete</span>
                                            </div>
                                        </div>
                                        <div class="border border-bottom-0 cah-document-img-wrap mb-0">
                                            <img [src]="imageSrc" class="img-fluid w-100">
                                        </div>
                                        <div class="cah-id-bottom">
                                            <p class="cah-fw-500 py-3 py-lg-3 py-sm-3 py-md-3 py-xs-3 mb-0">{{fileName}}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="d-flex justify-content-between mb-3 pb-3">
                                <mat-checkbox class="cah-font-16 cah-sign-in-remember-me" formControlName="checkMe"
                                    name="pass-validation" color="Primary" (click)="checkBtn()">By checking here, you
                                    certify that the doctors in your practice are
                                    covered by an active liability insurance policy.</mat-checkbox>
                            </div>
                            <div class="mat--error message-block">
                                <div class="mat-error error-message"
                                    *ngIf="veterinarianFormGroup.controls['checkMe'].hasError('required') && veterinarianFormGroup.controls['checkMe'].touched">
                                    {{message.error[13]}}</div>

                            </div>

                        </div>
                        <div class="px-5">
                            <button
                                [disabled]="!this.veterinarianFormGroup.valid || !ischeck "
                                type="button" class="btn btn-violet btn-lg w-100 fs-5 h-60 mt-2"
                                (click)="submitClinicForm()">Sign
                                Up</button>
                            <div class="text-center mt-4 pb-5">
                                <span class="text-gray cah-font-16">Already have an account?</span><a
                                    class="create-acc-link text-violet text-decoration-none ms-1 cah-font-16"
                                    routerLink="../pcv-signin">Sign In</a>
                            </div>
                        </div>
                    </div>
                </form>

                <form [formGroup]="passwordFormGroup">
                    <div class="w-100 cah-sign-up-step" [class.d-block]="step == 2">
                        <div class="pt-5 px-5">
                            <div class="field-content">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Enter Password</mat-label>
                                    <input matInput [type]="hide ? 'password' : 'text'" name="password"
                                        (keyup)="checkPassword()" formControlName="password" maxlength="16" matInput
                                        required>
                                    <button mat-icon-button matSuffix matTooltip="Toggle Visibility" type="button"
                                        (click)="hide = !hide">
                                        <mat-icon *ngIf="!hide">visibility</mat-icon>
                                    <mat-icon *ngIf="hide">visibility_off</mat-icon>
                                    </button>
                                </mat-form-field>
                                <div class="mat--error message-block">
                                    <div class="mat-error error-message"
                                        *ngIf="passwordFormGroup.controls['password'].hasError('required') && passwordFormGroup.controls['password'].touched">
                                        {{message.error[17]}}</div>
                                    <div class="mat-error error-message"
                                        *ngIf="passwordFormGroup.controls['password'].hasError('pattern') && passwordFormGroup.controls['password'].touched">
                                        {{message.error[18]}}</div>
                                    <div class="mat-error error-message"
                                        *ngIf="passwordFormGroup.controls['password'].hasError('whitespace') && passwordFormGroup.controls['password'].touched">
                                        {{message.error[18]}}</div>
                                </div>
                            </div>
                            <div class="field-content">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Confirm Password</mat-label>
                                    <input matInput formControlName="confirmPassword" maxlength="16" matInput
                                        [type]="chide ? 'password' : 'text'" name="confirm-password" required>
                                    <button mat-icon-button matSuffix matTooltip="Toggle Visibility" type="button"
                                        (click)="chide = !chide">
                                        <mat-icon *ngIf="!chide">visibility</mat-icon>
                                        <mat-icon *ngIf="chide">visibility_off</mat-icon>
                                    </button>
                                </mat-form-field>
                                <div class="mat--error">
                                    <div class="mat-error"
                                        *ngIf="passwordFormGroup.controls['confirmPassword'].hasError('passwordCompare')">
                                        {{message.error[16]}}</div>
                                </div>
                            </div>
                            <div class="mb-4">
                                <div>
                                    <mat-checkbox #lowerCase [disabled]=true class="cah-pointer-none example-margin"
                                        name="pass-validation" color="Primary" required>At least 1 lower case
                                        character</mat-checkbox>
                                </div>
                                <div>
                                    <mat-checkbox #upperCase [disabled]=true class="cah-pointer-none example-margin"
                                        name="pass-validation" color="Primary">At least 1 upper case
                                        character</mat-checkbox>
                                </div>
                                <div>
                                    <mat-checkbox [checked]="passwordHasNumber" class="cah-pointer-none example-margin"
                                        #oneNumeric [disabled]=true name="pass-validation" color="Primary">At least 1
                                        numeric character</mat-checkbox>
                                </div>
                                <div>
                                    <mat-checkbox #symbol [disabled]=true class="example-margin" color="Primary">Atleast
                                        1 symbol</mat-checkbox>
                                </div>
                                <div>
                                    <mat-checkbox #minLength [disabled]=true class="cah-pointer-none example-margin"
                                        name="pass-validation" color="Primary">Minimum 8 characters long</mat-checkbox>
                                </div>
                            </div>
                        </div>
                        <div class="px-5 mb-3 mb-lg-5 mb-md-5 text-center">
                            <button (click)="openTermsAndDocument()" [disabled]="!this.passwordFormGroup.valid"
                                class="btn btn-violet btn-lg w-100 fs-5 h-60 mt-2">Next</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>